var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useRecipe } from "@chakra-ui/react";
import { ApplyButton } from "@/components/cortex";
export var ApplyButtonWrapper = function (_a) {
    var job = _a.job, variant = _a.variant;
    var recipe = useRecipe({ key: "ApplyButtonWrapper" });
    var styles = recipe({ variant: variant });
    return (_jsx(Box, __assign({ css: styles }, { children: _jsx(ApplyButton, { applyUrl: job.url, label: "Apply" }) })));
};
